import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCoachWorkRoutines, patchCoachWorkRoutines } from './api';
import { coachWorkRoutineKeys } from './keys';
import { PatchCoachWorkRoutineBody } from './types';

export const useCoachWorkRoutines = ({
    centerId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    year: string;
    month: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: coachWorkRoutineKeys.list(centerId, year, month),
        queryFn: () => getCoachWorkRoutines({ centerId, year, month }),
        enabled: enabled && !!centerId,
        select: (data) => data?.data,
    });

export const usePatchCoachWorkRoutines = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            centerId,
            body,
        }: {
            centerId: string;
            body: PatchCoachWorkRoutineBody;
        }) => patchCoachWorkRoutines({ centerId, body }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: coachWorkRoutineKeys.list(
                    variables.centerId,
                    variables.body.year,
                    variables.body.month,
                ),
            });
        },
    });
};
